import React from 'react';
import classNameBind from 'classnames/bind';
import { TFunction } from 'react-i18next';
import { errorBoundary } from '@piwikpro/platform';
import {
  Card,
  View,
  Stack,
  OverlayView,
  withTranslation,
} from '@piwikpro/ui-components';
import styles from './TwoFactorConfigureOverlay.module.css';
import TwoFactorConfigure from './components/TwoFactorConfigure';
import TwoFactorBackupCodes from './components/TwoFactorBackupCodes';

const bindClasses = classNameBind.bind(styles);

export interface ITwoFactorConfigureOverlayProps {
  onClose: ({ setupCompleted }: { setupCompleted: boolean }) => void
  setupCompleted: boolean
  twoFactorAuthEnforced: boolean
  t: TFunction
}

export const TwoFactorConfigureOverlay: React.FC<ITwoFactorConfigureOverlayProps> = ({
  onClose,
  setupCompleted,
  twoFactorAuthEnforced,
  t,
}) => (
  <OverlayView
    isOpen
    onClose={() => onClose({ setupCompleted })}
    title={t(twoFactorAuthEnforced ? 'security.2fa-reset.title' : 'security.2fa.title')}
  >
    <View>
      <View.Body>
        <div className={bindClasses('container')}>
          <div className={bindClasses('inner-wrapper')}>
            <Stack
              fullHeight
              verticalAlignment="center"
              horizontalAlignment="middle"
            >
              <Stack.Item fill>
                <Card>
                  {setupCompleted
                    ? <TwoFactorBackupCodes onClose={onClose} />
                    : <TwoFactorConfigure />
                  }
                </Card>
              </Stack.Item>
            </Stack>
          </div>
        </div>
      </View.Body>
    </View>
  </OverlayView>
);

export default withTranslation(['profile'])(errorBoundary(TwoFactorConfigureOverlay));
